import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {DocumentsBrowserShell} from 'src/app/documents/DocumentsBrowserShell';
import {toDocumentTreeNodeId} from 'src/app/documents/documentTreeBrowserState';
import {DocumentFolderForm} from 'src/pages/Modules/DocumentManagement/shared/DocumentFolderForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {documentTitle} from '../documentHelpers';

export const CreateFolderPage = () => {
  useSetDocumentTitle(documentTitle);
  const {parentId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.DocumentManagement}>
      <DocumentsBrowserShell selectedId={toDocumentTreeNodeId(parentId)}>
        <DocumentFolderForm mode="create" parentId={parentId} />
      </DocumentsBrowserShell>
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.DocumentManagerCreateFolder(':parentId'),
  element: <CreateFolderPage />,
  module: ModuleEnum.Documents,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
